export interface IProps {
  title?: string;
  documentType?: string;
  institution?: string;
  date?: string;
  pdfUrl?: string;
  type?: DownloadFileType;
  description?: string;
}

export enum DownloadFileType {
  Info,
  Orders,
  Dialogue
}
